<template>
  <vf-button
    id="notify-me"
    class="relative w-full"
    :size="{ sm: 'sm', lg: 'md' }"
    :style="{ 'scroll-margin-top': `${header.height.full}px` }"
    @click="openNotifyMe"
  >
    {{ $t.notifyMe }}
    <dialog-notify-me size="xs" />
  </vf-button>
</template>

<script lang="ts" setup>
const { enableScrollToError = false } = defineProps<{
  enableScrollToError?: boolean
}>()
// NOTE The modal is inside the button so it can be the root component and get non-prop attributes assigned.
// The modal itself is rendered with a teleport so it will not affect the DOM.
const emit = defineEmits<{ 'notify-sign-up-success': [] }>()

const { $gtm } = useNuxtApp()
const { dialogOptions } = useAppConfig().components.product.notifyMe
const header = useHeaderStore()
const {
  attributeSelection,
  handleNextAttribute,
  isComingSoon,
  product,
  productColor,
  noVariantSelected,
  setNotification,
  selectedVariant
} = usePdp()

const DialogNotifyMe = createDialog('notify-me', dialogOptions)

const openNotifyMe = () => {
  if (!product.value) return
  if (!selectedVariant.value && !isComingSoon.value) {
    if (enableScrollToError) {
      noVariantSelected()
      scrollToElement('sizePickers')
    }
    else {
      handleNextAttribute({}, () => openNotifyMe())
    }
    return
  }

  const attributeSelectionLabels = useAttributeSelectionLabels(product, attributeSelection)

  const size = attributeSelectionLabels.value.size?.value || attributeSelection.size
  const length = attributeSelection.length
  const width = attributeSelection.width

  const gtmEventLabel = `${product.value.id} - ${productColor.value?.label}: ${[size, length, width].filter(Boolean).join('/')}`
  DialogNotifyMe.keep().open({
    productId: isComingSoon.value ? product.value.id : selectedVariant.value.id,
    selectedAttributes: attributeSelectionLabels.value,
    isComingSoon: isComingSoon.value,
    gtmEventLabel,
    subscriptionType: product.value.subscriptionType,
    setNotification,
    productName: product.value.name,
    onNotifySignUp: () => emit('notify-sign-up-success')
  })

  $gtm.push('pdpPage.onNotifyMeOpen', product.value.id)
}

defineExpose({ openNotifyMe })
</script>
